module.exports = __webpack_public_path__ + "media/outbou2.a1f45f76.mp4";